import './sass/home.scss'
import React from 'react';
import { useEffect, useState } from "react";
import LogoClinica from './img/logo_integrada.png';
import ImgSesc from "./img/LOGO_SESC.png";
import TabelaPrecos from "./doc/PORTARIA_CLINICA.pdf";

import {useToast, Spinner, Box, Text, Image, Input, VStack} from '@chakra-ui/react'


import LanguageIcon from './img/REDES-SOCIAIS_site.png';
import SpotifyIcon from './img/REDES-SOCIAIS_spotify.png';
import FacebookIcon from './img/REDES-SOCIAIS_facebook.png';
import TwitterIcon from './img/REDES-SOCIAIS-_twitter.png';
import InstagramIcon from './img/REDES-SOCIAIS_instagram.png';
import YouTubeIcon from './img/REDES-SOCIAIS_youtube.png';
import WhatsAppIcon from './img/REDES-SOCIAIS-whatsapp.png';

import { validate } from "node-cpf";
import { ApiClientela } from './api/ApiClientela';
import { useNavigate } from 'react-router-dom';

function Home() {
    const urlEspaco = "https://espacodigital.sescrn.com.br/espaco-digital/habilitacao/solicitacao";
    const urlWp = "https://api.whatsapp.com/send?phone=558431330360";
    const unidadesSesc = "https://sescrn.com.br/unidades/";


    return (
        <section className="card-page">
            <HomePageTop />
            <hr />
            <div className="card-ordem">
                <VStack gap={'10px'}>
                    <div id="card-form">
                        <ConsultaCartaoHeader text={"Se ainda não é credenciado"}/>
                        <p className='card-row'> Solicite sua credencial no site <a
                            style={{color: '#164282', fontWeight: 'bold'}} href={urlEspaco} target="_blank"
                            rel="noopener noreferrer"> Espaço Digital</a>.</p>
                        <p className='card-row'> Entre em contato conosco via <a
                            style={{color: '#164282', fontWeight: 'bold'}} href={urlWp} target="_blank"
                            rel="noopener noreferrer"> WhatsApp</a>.</p>
                        <p className='card-row'> Compareça a uma unidade <a
                            style={{color: '#164282', fontWeight: 'bold'}} href={unidadesSesc} target="_blank"
                            rel="noopener noreferrer"> Sesc RN</a>.</p>
                    </div>
                    <div id="card-form">
                        <h2>Consulte Preços</h2>
                        <p className='card-row'> Acesse a tabela de preços da <a
                            style={{color: '#164282', fontWeight: 'bold'}} href={TabelaPrecos} target="_blank"
                            rel="noopener noreferrer"> Clínica Integrada do Sesc RN</a>.</p>
                    </div>
                </VStack>
                <Box id="card-form" >
                    <ConsultaCartaoHeader text={"Se você é credenciado"}/>
                    <ConsultaCartaoForm/>
                    <ConsultaCartaoFooter/>
                </Box>
            </div>
        </section>

    );
}
const InputStatus = {
    VAZIO: 0,
    INVALIDO: 1,
    VALIDO: 2
};
function HomePageTop() {
    return (
        <>
            <Box display={"flex"} maxW={'50%'}>
                <Image src={LogoClinica} loading="lazy"
                    alt="Sesc Logo" maxH="300px">
                </Image>
            </Box>
        </>
    )
}

function ConsultaCartaoHeader(props) {
    return <>
        <div className="card-header">
            <img src={ImgSesc} loading="lazy"
                alt="Sesc Logo"/>
        </div>
        <h2>{props.text}</h2>
    </>;
}

function ConsultaCartaoFooter() {
    return <div className="card-footer">
        <div>
            <a title="Facebook" href="https://www.facebook.com/sescrn">
            <img src={FacebookIcon} loading="lazy"
                alt="Facebook Icone"/>
            </a>
            <a title="Twitter" href="https://twitter.com/sesc_rn">
            <img src={TwitterIcon} loading="lazy"
                alt="Twitter Icone"/>
            </a>
            <a title="Instagram" href="https://www.instagram.com/sescrn">
                <img src={InstagramIcon} loading="lazy"
                alt="Instagram Icone"/>
            </a>
            <a title="Youtube" href="https://www.youtube.com/user/SESCRN">
                <img src={YouTubeIcon} loading="lazy"
                alt="Youtube Icone"/>
            </a>
            <a title="Spotify" href="https://www.youtube.com/user/SESCRN">
                <img src={SpotifyIcon} loading="lazy"
                alt="Spotify Icone"/>
            </a>
            <a title="Whatsapp" href="https://wa.me/message/MHDWH5DAMIHBK1">
                <img src={WhatsAppIcon} loading="lazy"
                alt="Youtube Icone"/>
            </a>
        </div>
        <a href="https://www.sescrn.com.br/">
        <img src={LanguageIcon} loading="lazy"
                alt="Site Icone"/>
        </a>
    </div>;
}

function ConsultaCartaoForm() {
    const
        [loading, setLoading] = useState(false),
        [cpf, setCpf] = useState(''),
        [statusCpf, setStatusCpf] = useState(InputStatus.VAZIO),
        [canSubmit, setCanSubmit] = useState(false),
        [credencial, setCredencial] = useState(null),
        // [openModal, setOpenModal] = useState(null),
        toast = useToast(),
        navigate = useNavigate();

    useEffect(() => {
        if (cpf.length < 1)
            setStatusCpf(InputStatus.VAZIO);
        else if (validate(cpf))
            setStatusCpf(InputStatus.VALIDO);
        else setStatusCpf(InputStatus.INVALIDO);
    }, [cpf]);



    useEffect(() => {
        if ((statusCpf === InputStatus.VALIDO))
            setCanSubmit(true);
        else setCanSubmit(false);
    }, [statusCpf]);


    const handleCpfChange = (ev) => {
        setCpf(/\d*/.exec(ev.target.value)[0]);
    };

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        setLoading(true);
        try {
            const data = await ApiClientela.getClientela(cpf);
            if (typeof (data) === 'object') {
                setCredencial(data);
                setCanSubmit(false);
                toast({
                    title: `Cliente SESC você será redirecionado!`,
                    status: "success"
                });
            }
            else {
                toast({
                    title: `Erro ao consultar dados!`,
                    status: "error"
                });
                setCpf('');
                setCredencial(null);
                // setOpenModal(true);
            }
        } catch (e) {
            setCredencial(null);
            setCpf('');
        } finally {
            setLoading(false);
        }
    }

    const form = () => {
        return <form className="card-main form" onSubmit={handleSubmit}>
            <div className="form-control">
                <Text htmlFor="icpf">CPF</Text>
                <input id="icpf" type="text" placeholder="00000000000" value={cpf} required
                    className={statusCpf === InputStatus.INVALIDO ? 'invalido' : ''}
                    disabled={loading} onChange={handleCpfChange} maxLength={11} />
                <small>Somente números.</small>
            </div>
            {loading
                ? <Spinner size='xs' />
                : <button className="btn-primary" type="submit" disabled={!canSubmit}>
                    VERIFICAR
                </button>
            }
        </form>;
    }

    return <>
        <div hidden={true}>{credencial ? setTimeout(() => { navigate("/agendamento", { state: { credencial } }) }, "3000") : null}</div>
        {form()}
    </>
}

export default Home;
